function EntityFormPage({ listLabel, itemLabel, title, onBack, actions, children }) {
  return (
    <section className="admin-section admin-form-page">
      <div className="admin-back-row">
        <button type="button" className="admin-back-btn" onClick={onBack} aria-label="Retour">
          ←
        </button>
        <span className="admin-breadcrumb">
          {listLabel}
          {itemLabel ? (
            <>
              {' '}
              / <b>{itemLabel}</b>
            </>
          ) : null}
        </span>
      </div>
      <div className="admin-actions" style={{ justifyContent: 'space-between', marginBottom: 'var(--space-3)' }}>
        <h2>{title}</h2>
        {actions}
      </div>
      {children}
    </section>
  );
}

export default EntityFormPage;
